import { Component } from 'react';

const reportToMonitoring = (error) => {
    if (typeof window === 'undefined') return;
    if (typeof window.reportError === 'function') {
        window.reportError(error);
        return;
    }
    setTimeout(() => {
        throw error;
    });
};

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, resetKey: props.resetKey };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.resetKey !== state.resetKey) {
            return { hasError: false, resetKey: props.resetKey };
        }
        return null;
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        const { onError } = this.props;
        reportToMonitoring(error);
        if (onError) onError(error);
    }

    render() {
        const { hasError } = this.state;
        const { fallback = null, children } = this.props;
        return hasError ? fallback : children;
    }
}
